<template>
<!-- 
    * Copyright: T-Systems México S.A. de C.V.
    * Descripción: Vista 404, se muestra cuando se direcciona a una vista no existente 
    * Autor: 
    * F.Creación: 
  -->
  <layout>
     <!-- Contenido -->
    <template v-slot:content>
      <v-container >
        <v-row
          align="center"
          justify="center" >
          <v-col
            cols="12"
            sm="8"
            md="4">
            <v-card class="elevation-0">
                         <v-card-text align="center"
          justify="center" >
                <div class="display-4">404</div>
                <div class="primary--text caption">{{$t('notFound')}}</div>
              </v-card-text>
              
            </v-card>
          </v-col>
        </v-row>
      </v-container>

    </template>
  </layout>
    
  
</template>

<script>
  import Layout from "@/components/Layouts/Anonymous"
  import i18nMessages from './i18n.messages'

  export default {
    i18n: i18nMessages,
    components: {
      'layout': Layout
    },
    created () {
      this.$i18n.locale = this.locale
    },
    mounted: () => {
    },
    beforeDestroy () {
    },
    data () {
      return {
      }
    },
    computed: {
    locale () {
      return this.$store.getters['locale']
    }
  },
  watch: {
    locale (value) {
      this.$i18n.locale = value
    }
  }

  }
</script>